<ng-container *ngIf="!open">
    <div class="left-header">
        <div class="title" *ngIf="selectedGate"
            [style.background-color]="selectedGate.backColor?.web || null"
            [style.color]="selectedGate.foreColor?.web || null">
            {{selectedGate.gateName}}
        </div>
        <options class="show-label no-title left" [optionstrip]="gateOptions"
            (clickOption)="clickGateOption.emit($event)"></options>
    </div>
    <div class="gate-routes">
        <shared-forklift-left-route *ngFor="let route of selectedGatePlates | orderbyaccesscontrolgateplatedto:true"
            [value]="route" (clickRoute)="clickRoute.emit($event)"></shared-forklift-left-route>
    </div>
</ng-container>
<div class="gates-body" *ngIf="open">
    <div class="gate-column" *ngFor="let gate of gates | sortBy: 'gateOrder'">
        <div class="gate-header"
            [style.background-color]="gate.backColor?.web || null"
            [style.color]="gate.foreColor?.web || null">{{ gate.gateName }}</div>
        <div class="gate-routes">
            <shared-forklift-left-route *ngFor="let route of gate.plates | orderbyaccesscontrolgateplatedto:true"
                [value]="route" (clickRoute)="clickRoute.emit($event)"></shared-forklift-left-route>

        </div>
    </div>
</div>